<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
       Duplicate Attendance Report -Front
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-3 px-1">
                <label class="Label"> From Date<span class="text-danger">*</span></label>
                <div class="input-group">
                    <input class="form-control" placeholder="yyyy-mm-dd" name="fromdate " placeholder="Ex. DD/MM/YYYY"
                        [(ngModel)]="FromDate" #HolidayDate="ngModel" ngbDatepicker #d="ngbDatepicker"
                        [ngModelOptions]="{standalone: true}" required readonly />
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()"
                        type="button"></button>
                    <div class="invalid-feedback">
                        Please enter from date !
                    </div>
                </div>
            </div>
            <div class="col-md-3 px-1">
                <label class="Label"> To Date<span class="text-danger">*</span></label>
                <div class="input-group">
                    <input class="form-control" placeholder="yyyy-mm-dd" name="todate " placeholder="Ex. DD/MM/YYYY"
                        [(ngModel)]="ToDate" #HolidayDate="ngModel" ngbDatepicker #d1="ngbDatepicker"
                        [ngModelOptions]="{standalone: true}" required readonly />
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d1.toggle()"
                        type="button"></button>
                    <div class="invalid-feedback">
                        Please enter from date !
                    </div>
                </div>
            </div>
            <div class="col-md-3 px-1">
                <label class="Label">Approval Type<span class="text-danger">*</span></label>
                <ng-select name="allocationtype" [(ngModel)]="ApprovalStatus" placeholder="Select Approval Type">
                    <ng-option [value]="'All'">
                      All
                    </ng-option>
                    <ng-option [value]="'Approved'">
                      Approved
                    </ng-option>
                    <ng-option [value]="'Rejected'">
                      Rejected
                    </ng-option>
                    <ng-option [value]="'Pending'">
                      Pending
                    </ng-option>
                  </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-4 px-1">
                <label class="Label">Branch</label>
                <ng-select name="branch" [items]="BranchMaster" bindLabel="BranchName" bindValue="BranchMasterID"
                    [(ngModel)]="BranchId" (change)=" onSelectChange('Branch'); ComboLoad('Client')" placeholder="Select Branch">
                    <ng-option *ngFor="let segment of BranchMaster" [value]="segment.BranchMasterID">
                        {{ segment.BranchName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-8 px-1">
                <label class="Label">Client</label>
                <ng-select name="client" [items]="ClientLoad" bindLabel="ClientGroupName"
                    bindValue="ClientGroupMasterID" [(ngModel)]="ClientId"
                    (change)="onSelectChange('Client'); ComboLoad('Site')" placeholder="Select Client">
                    <ng-option *ngFor="let segment of ClientLoad" [value]="segment.ClientGroupMasterID">
                        {{ segment.ClientGroupName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-8 px-1">
                <label class="Label">Site</label>
                <ng-select name="site" [items]="SiteLoad" bindLabel="SiteName" bindValue="SiteMasterID"
                    [(ngModel)]="SiteId" placeholder="Select Site">
                    <ng-option *ngFor="let segment of SiteLoad" [value]="segment.SiteMasterID">
                        {{ segment.SiteName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
          
            <div class="col-md-3 px-1">
                <label class="Label">Employee Code</label>
                <input name="empcode"  type="text" placeholder="Enter Employee Code" class="form-control" />
            </div>
            <div class="col-md-2 px-1"><br>
                <button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="submit" (click)="Load()">
                    <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Cancel':'Loading...'}}</button>
        </div>
    </div>
</div>